// Shared profile field options and descriptions

export const SHIO_OPTIONS = [
  'Tikus (Rat)', 'Kerbau (Ox)', 'Macan (Tiger)', 'Kelinci (Rabbit)',
  'Naga (Dragon)', 'Ular (Snake)', 'Kuda (Horse)', 'Kambing (Goat)',
  'Monyet (Monkey)', 'Ayam (Rooster)', 'Anjing (Dog)', 'Babi (Pig)'
];

export const MBTI_OPTIONS = [
  'INTJ', 'INTP', 'ENTJ', 'ENTP',
  'INFJ', 'INFP', 'ENFJ', 'ENFP',
  'ISTJ', 'ISFJ', 'ESTJ', 'ESFJ',
  'ISTP', 'ISFP', 'ESTP', 'ESFP'
];

export const ZODIAC_OPTIONS = [
  'Aries', 'Taurus', 'Gemini', 'Cancer',
  'Leo', 'Virgo', 'Libra', 'Scorpio',
  'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'
];

export const MARRIAGE_STATUS_OPTIONS = [
  { value: 'single', en: 'Single', id: 'Lajang' },
  { value: 'divorced_m', en: 'Divorced (Male)', id: 'Duda Cerai' },
  { value: 'divorced_f', en: 'Divorced (Female)', id: 'Janda Cerai' },
  { value: 'widower', en: 'Widower', id: 'Duda' },
  { value: 'widow', en: 'Widow', id: 'Janda' },
  { value: 'has_children', en: 'Has Children', id: 'Punya Anak' },
  { value: 'single_parent', en: 'Single Parent', id: 'Single Parent' },
];

export const TUJUAN_OPTIONS = [
  { value: 'serius', en: 'Serious Relationship', id: 'Cari Jodoh Serius' },
  { value: 'santai', en: 'Casual Dating', id: 'Cari Jodoh Santai' },
  { value: 'networking', en: 'Networking', id: 'Networking' },
  { value: 'teman', en: 'Looking for Friends', id: 'Mencari Teman' },
];

export const INCOME_RANGE_OPTIONS = [
  '< 5 Juta',
  '5 - 10 Juta',
  '10 - 20 Juta',
  '20 - 50 Juta',
  '50 - 100 Juta',
  '> 100 Juta',
  'Prefer not to say',
];

export const ALIRAN_AGAMA_OPTIONS = {
  'Buddha': ['Theravada', 'Mahayana', 'Vajrayana', 'Zen', 'Nichiren', 'Tridharma', 'Lainnya'],
  'Kristen Protestan': ['Calvinist/Reformed', 'Lutheran', 'Methodist', 'Baptis', 'Pantekosta', 'Karismatik', 'Advent', 'Evangelical', 'Anglikan', 'Lainnya'],
  'Katolik': ['Katolik Roma', 'Katolik Timur', 'Lainnya'],
  'Islam': ['Sunni', 'Syiah', 'Sufi', 'Ahmadiyah', 'NU', 'Muhammadiyah', 'Salafi', 'Lainnya'],
  'Hindu': ['Shaivism', 'Vaishnavism', 'Shaktism', 'Hindu Dharma Bali', 'Lainnya'],
  'Konghucu': ['Konfusianisme Klasik', 'Neo-Konfusianisme', 'Lainnya'],
  'Ateis/Agnostik': ['Ateis', 'Agnostik', 'Spiritual tapi tidak religius'],
  'Lainnya': ['Lainnya'],
};

export const FIELD_LINKS = {
  mbti: 'https://www.16personalities.com/free-personality-test',
  shio: 'https://en.wikipedia.org/wiki/Chinese_zodiac#Years',
  zodiac: 'https://www.astrology.com/zodiac-signs',
};

export const FIELD_DESCRIPTIONS = {
  mbti: {
    en: 'Myers-Briggs Type Indicator — a personality framework with 16 types based on how you perceive the world and make decisions.',
    id: 'Myers-Briggs Type Indicator — kerangka kepribadian dengan 16 tipe berdasarkan cara Anda memandang dunia dan membuat keputusan.',
  },
  shio: {
    en: 'Chinese Zodiac (Shio) — based on your birth year in the 12-year cycle of animals in Chinese astrology.',
    id: 'Shio — berdasarkan tahun kelahiran Anda dalam siklus 12 tahun hewan dalam astrologi Tiongkok.',
  },
  zodiac: {
    en: 'Western Zodiac — your star sign based on your birth date, representing personality traits and compatibility.',
    id: 'Zodiak Barat — tanda bintang berdasarkan tanggal lahir Anda, merepresentasikan sifat kepribadian dan kecocokan.',
  },
  aliran_agama: {
    en: 'Religious sect/denomination — the specific branch or tradition within your religion.',
    id: 'Aliran agama — cabang atau tradisi spesifik dalam agama Anda.',
  },
};
